document.addEventListener("DOMContentLoaded", (event) => {
	const imgGroupsWithArrow = document.querySelectorAll(".img-group");
	if (imgGroupsWithArrow && imgGroupsWithArrow.length > 0) {
		imgGroupsWithArrow.forEach((group) => {
			const imgDiv = group.querySelector(".et_pb_image img");

			const arrowContainer = group.querySelector(".et_pb_code_inner ");
			if (!arrowContainer) return;
			const resizeObserver = new ResizeObserver((entries) => {
				for (let entry of entries) {
					if (entry.target === group) {
						const imgDivHeight = imgDiv.getBoundingClientRect().height;
						arrowContainer.style.height = `${imgDivHeight}px`;
						// console.log(arrowContainer);
					}
				}
			});
			resizeObserver.observe(group);
		});
	}

	/**
	 * Home Hero Video
	 */
	const homeHero = document.querySelector(".home-hero");
	if (homeHero) {
		const video = homeHero.querySelector("video");
		if (video) {
			const img = video.closest(".video-square").querySelector(".et_pb_image");
			video.removeAttribute("controls");
			video.setAttribute("autoplay", "");
			video.muted = true;
			video.loop = true;
			video.load();
			setTimeout(() => img.classList.add("hide"), 200);
		}
	}
});
